import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import intl from 'react-intl-universal';
import { Field } from 'redux-form';
import { validateName } from 'utils/guest-utils';
import MuiTextField from 'components/ModalInput/MuiInput';

interface Props {
  handleJoinMeeting: Function;
  name: string;
  error: string | undefined;
  onChange: any;
}

const NameInput = () => {
  const classes = userFieldStyles();
  return (
    <Box mt={4} width={'100%'} data-testid="name">
      <Field
        component={MuiTextField}
        label={intl.get('name')}
        name={'name'}
        inputProps={{
          maxLength: 32,
          'data-testid': 'guest-name-input'
        }}
        className={classes.formField}
        type="text"
        validate={validateName}
      />
    </Box>
  );
};

const userFieldStyles = makeStyles(() => ({
  formField: {
    maxWidth: '500px',
    width: '100%'
  }
}));

export default NameInput;
